module.exports = __webpack_public_path__ + "static/img/iconmenu07_white.dff8c8be.svg";